import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
/**
 * Abstract PaymentMethod class that should be extended when implementing any payment
 * method to be supported by Braintree.
 */
var AbstractPaymentMethodService = /*#__PURE__*/_createClass(function AbstractPaymentMethodService() {
  _classCallCheck(this, AbstractPaymentMethodService);
});
export { AbstractPaymentMethodService as default };


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/business/processors/braintree/AbstractPaymentMethodService.js
// module id = 1710
// module chunks = 11